import { html, render } from "lit";
import mixpanel from "mixpanel-browser";

import "./main.css";
import "./ks";
import { Api} from "./common/api";
import { getConfigByEnv } from './config';
import { captureAttribution } from './common/analytics.js';
import './shell.js';

export async function main() {
  if (!window.URLPattern) {
    await import("urlpattern-polyfill");
  }
  if (!window.navigation) {
    await import("@virtualstate/navigation/polyfill");
  }
  const config = getConfigByEnv(window.ks.env);
  const api = new Api({ baseUrl: config.apiBaseUrl });
  const tokenKey = "accessToken";
  const ssoKey = "ks_sso";
  let tokenValue = localStorage.getItem(tokenKey);
  if (tokenValue) {
    api.accessToken = tokenValue;
  } else if (localStorage.getItem(ssoKey)) {
    try {
      const tokenRes = await api.retrieveSsoToken();
      const tokenJson = await tokenRes.json();
      if (tokenRes.ok) {
        const accessToken = tokenJson?.['access_token'];
        if (accessToken) {
          localStorage.setItem(tokenKey, accessToken);
          api.accessToken = accessToken;
          tokenValue = accessToken;
        }
      } else {
        // SSO session expired — clear the flag
        localStorage.removeItem(ssoKey);
      }
    } catch (err) {
      // Network error — continue without a token, app will show login
      localStorage.removeItem(ssoKey);
    }
  }

  const url = new URL(window.location.href);
  let theme = "";
  if (url.searchParams.has("theme")) {
    theme = url.searchParams.get("theme");
  } else {
    setTimeout(() => setupHubspot(config), 1000);
  }

  const template = html`
    <ks-booking-shell
      .api=${api}
      .tokenValue=${tokenValue}
      .config=${config}
      .theme=${theme}
      @login=${(e) => {
        localStorage.setItem(tokenKey, e.detail);
        api.accessToken = e.detail;
      }}
      @logout=${async (e) => {
        await api.logout();
        localStorage.removeItem(tokenKey);
        localStorage.removeItem(ssoKey);
        api.accessToken = undefined;
      }}
      @user=${(e) => {
        const user = e.detail;
        let _hsq = (window._hsq = window._hsq || []);
        _hsq.push([
          'identify',
          {
            email: user.email,
            id: user.id,
          },
        ]);
        mixpanel.identify(user.id);
        mixpanel.people.set({
          '$name': user.full_name,
          '$email': user.email,
        });
      }}
    ></ks-booking-shell>
  `;
  const container = document.querySelector('#container');

  container.innerHTML = '';
  render(template, container);

  mixpanel.init(config.mixpanelToken, {
    debug: config.mixpanelDebug,
    autocapture: config.mixpanelAutocapture,
    record_sessions_percent: config.mixpanelRecordSessionsPercent,
    api_host: 'https://api-eu.mixpanel.com',
  });
  captureAttribution();
}

function setupHubspot(config) {
  let el = document.createElement('script');
  el.id = 'hs-script-loader';
  el.src = `//${config.hubspotScriptHost}/${config.hubspotPortalId}.js`;
  document.body.appendChild(el);
}
